import styled from 'common/styled-components';
import { IconButton, Paper } from '@material-ui/core';

export const SegmentPaper = styled(Paper)<{ hasEntry: boolean, submitted: boolean }>`
  width: 100%;
  flex-direction: row;
  display: flex;
  padding: 1px;
  border-left: 5px solid ${
    (props) => 
    props.hasEntry ? 
        props.submitted ?  props.theme.summary.green : props.theme.summary.orange : 
        props.theme.summary.grey} ;
  align-items: center;
`;
export const DateContainer = styled.div`
  width: 100px;
  margin-left: 10px;
`;
export const TimeContainer = styled.div`
  width: 80px;
  color: ${props => props.theme.black.light};
  cursor: pointer;
  outline: none;
  &:focus {
    font-weight: 500;
  }
`;
export const NarrativeContainer = styled.div`  
  flex: 1;
  overflow: auto;
`;
export const ActionContainer = styled.div`
  width: 0px;
  white-space: nowrap;
  overflow: hidden;
  height: 30px;
  transition: 0.3s;
  text-align: center;
  &:focus {
    width: 52px;
  }
  ${SegmentPaper}:hover & {
    width: 52px;
  }
  ${SegmentPaper}:focus-within & {
    width: 52px;
  }
`;
export const Control = styled.div`
  margin-left: 8px;
`;
export const CompactIconButton = styled(IconButton)`
  padding: 2px !important;
`;
export const Popover = styled.div`
  padding: 2px !important;
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 5px;
  width: 100px;
`;
export const RunningItemActionContainer = styled.div`
  width: 0px;
  white-space: nowrap;
  overflow: hidden;
  height: 30px;
  transition: 0.3s;
  ${SegmentPaper}:hover & {
    width: 45px;
  }
  ${SegmentPaper}:focus-within & {
    width: 45px;
  }
`;
export const Star = styled.span`
  color: ${props => props.theme.primary.main};
  padding: 10px;
  align-self: normal;
`;